export type AuditMetadata = {
    id?: string;
    recordId?: string;
    createdAt?: string;
    createdBy?: string;
    createdByName?: string;
    createdByUser?: string;
    creatorName?: string;
    updatedAt?: string;
    updatedBy?: string;
    updatedByName?: string;
    updatedByUser?: string;
    updaterName?: string;
};

export const extractEditableFields = <TEditable extends Record<string, any>>(
    form: Partial<TEditable & AuditMetadata>,
): Partial<TEditable> => {
    const {
        id,
        recordId,
        createdAt,
        createdBy,
        createdByName,
        createdByUser,
        creatorName,
        updatedAt,
        updatedBy,
        updatedByName,
        updatedByUser,
        updaterName,
        ...editable
    } = form as TEditable & AuditMetadata;

    return editable as Partial<TEditable>;
};

export const resolveCreatedBy = (record: Partial<AuditMetadata>) =>
    record.createdByName ?? record.createdByUser ?? record.creatorName ?? record.createdBy ?? '';

export const resolveUpdatedBy = (record: Partial<AuditMetadata>) =>
    record.updatedByName ?? record.updatedByUser ?? record.updaterName ?? record.updatedBy ?? '';
